import { MiscExpenseStateTypes, MiscExpenseActionTypes } from "./MiscExpense.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MiscExpenseStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MiscExpenseReducer = (
  state: MiscExpenseStateTypes = INITIAL_STATE,
  action: any
): MiscExpenseStateTypes => {
  switch (action.type) {
    case MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE:
      return { ...state, fetchAll: { error: null, payload: [], isPending: true, isSuccessful: false } };
    case MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE_RESET:
      return { ...state, fetchAll: resetApiCallState([]) };
    case MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE_FAILURE:
      return { ...state, fetchAll: { payload: [], isPending: false, isSuccessful: false, error: action.payload } };
    case MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE_SUCCESS:
      return { ...state, fetchAll: { error: null, isPending: false, isSuccessful: true, payload: action.payload } };

    case MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE:
      return { ...state, fetchOne: { error: null, payload: {}, isPending: true, isSuccessful: false } };
    case MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE_RESET:
      return { ...state, fetchOne: resetApiCallState({}) };
    case MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE_FAILURE:
      return { ...state, fetchOne: { payload: {}, isPending: false, isSuccessful: false, error: action.payload } };
    case MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE_SUCCESS:
      return { ...state, fetchOne: { error: null, isPending: false, isSuccessful: true, payload: action.payload } };

    default:
      return state;
  }
};

export default MiscExpenseReducer;
